<template>
  <ym-popup class="public-welfare-mobile-login-popup"
            v-model="visible"
  >
    <div class="public-welfare-mobile-login-container">
      <div class="public-welfare-mobile-login-header">
        登录参与活动
      </div>
      <form class="public-welfare-mobile-login-form"
            @submit.prevent="handleSubmit"
      >
        <div class="form-fields">
          <div class="mobile-block">
            <span slot="left">+86</span>
            <ym-field class="ym-field ym-field-mobile"
                      v-model.trim="mobile"
                      type="tel"
                      placeholder="输入手机号"
                      :attr="{ autocomplete: false, maxlength: 11 }"
                      @keyup.enter.prevent="handleSubmit"
            />
          </div>
          <ym-field class="ym-field ym-field-sms-code"
                    v-model.trim="smsCode"
                    placeholder="输入验证码"
                    :attr="{ autocomplete: false, maxlength: 6 }"
                    @keyup.enter.prevent="handleSubmit"
          >
            <ym-button class="sms-btn"
                       id="geetest-verify-sms-btn"
                       plain
                       type="primary"
                       size="small"
                       :disabled="disabledSmsCode"
            >{{ smsCodeText }}
            </ym-button>
          </ym-field>
        </div>
        <div class="form-bottom">
          <ym-button class="submit-btn"
                     size="large"
                     type="primary"
                     round
                     :disabled="disabled"
                     @click.prevent="handleSubmit"
          >
            登 录
          </ym-button>
        </div>
        <div class="login-hint">
          点击登录表示您已阅读并同意
          <span @click="goAgreement">《服务协议》</span>
        </div>
      </form>
    </div>
  </ym-popup>
</template>

<script>
  import { Field, Button } from 'ym-mint-ui';
  import { Popup } from '@ymba/ym-ui';
  import validator from '@/utils/validator';
  import { locationHref } from '@/utils';
  import geetestMixin from '@/mixins/geetest';

  export default {
    name: 'MobileLoginPopup',
    mixins: [geetestMixin],
    components: {
      'ym-popup': Popup,
      'ym-field': Field,
      'ym-button': Button,
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        visible: false,
        smsCode: '',
        submitDisabled: false,
        agreementUrl: 'https://m.youthmba.com/user/term',
        smsType: 'verify',
      };
    },
    computed: {
      disabledSmsCode() {
        return this.mobile === '' || this.smsCodeDisabled;
      },
      disabled() {
        return this.mobile === ''
          || this.smsCode === ''
          || this.submitDisabled;
      },
    },
    watch: {
      show(val) {
        this.visible = val;
        if (val) this.geetestVerify();
      },
      visible(val) {
        this.$emit('update:show', val);
      },
      mobile(val) {
        if (this.smsCodeText.indexOf('已发送') !== -1) return;
        if (!validator.isMobile(val)) {
          this.smsCodeDisabled = true;
          return;
        }
        this.smsCodeDisabled = false;
      },
    },
    methods: {
      async handleSubmit() {
        if (!validator.isMobile(this.mobile)) {
          this.$toast('请填写正确的手机号');
          return;
        }
        if (validator.isEmpty(this.smsCode)) {
          this.$toast('请填写验证码');
          return;
        }
        this.submitDisabled = true;
        this.visible = false;
        this.$emit('submit', {
          mobile: this.mobile,
          sms_code: this.smsCode,
        });
        this.mobile = '';
        this.smsCode = '';
        this.smsCodeDisabled = false;
        this.smsCodeText = '获取验证码';
        this.submitDisabled = false;
      },
      goAgreement() {
        locationHref(this.agreementUrl);
      },
    },
    created() {
      this.visible = this.show;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .public-welfare-mobile-login {
    &-popup {
      width: 654px;
      height: 750px;
      background: @color-white;
      border-radius: 44px;
      overflow: hidden;
    }
    &-header {
      width: 100%;
      height: 120px;
      margin-bottom: 86px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @color-white;
      font-size: 40px;
      font-weight: @font-weight-strong;
      text-align: center;
      line-height: 1.2;
      background: #ffc546;
    }
    &-form {
      box-sizing: border-box;
      padding: 0 80px 82px 80px;
      .mobile-block {
        box-sizing: border-box;
        width: 100%;
        margin-bottom: 40px;
        padding-left: 48px;
        display: flex;
        align-items: center;
        background: #e5e5e5;
        span {
          color: @color-text-lighter;
          font-size: 28px;
          line-height: 1.3;
        }
      }
      /deep/ .ym-field {
        box-sizing: border-box;
        height: 84px;
        background: #e5e5e5;
        font-size: @font-size-medium;
        &.is-active {
          border: none;
        }
        .mint-field-other {
          display: flex;
          align-items: center;
        }
      }
      /deep/ .ym-field-mobile {
        padding-left: 10px;
      }
      /deep/ .ym-field-sms-code {
        padding-left: 48px;
        padding-right: 12px;
      }
      .sms-btn {
        color: #ed6d60;
        border-color: #ed6d60;
      }
      .form-bottom {
        box-sizing: border-box;
        margin-top: 76px;
        padding: 0 60px;
        .submit-btn {
          height: 90px;
          background: #ed6d60;
        }
      }
      .login-hint {
        margin-top: 48px;
        color: @color-text-lighter;
        font-size: 24px;
        line-height: 1;
        text-align: center;
      }
    }
  }
</style>
